import { message, PageHeader, Popconfirm, Space, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico, dineroDisabledMask } from "../../../Components/Items";
import { CloseCircleOutlined, BookFilled } from "@ant-design/icons";
import MandarCorreoDevolucion from "./MandarCorreoDevolucion/MandarCorreoDevolucion";
import CancelarDevolucion from "./CancelarDevolucion/CancelarDevolucion";
import { obtenerEstadoCancelacion } from "../../../Utils/estatusSat.utils";

class Devoluciones extends Component {
  tableRef = null;
  state = {
    todasDevoluciones: [],
    loading: false,
    totalRecords: 0,
    valor: 0,
    modalCorreo: false,
    modalCorreoId: null,
    modalCancelarDevolucion: false,
    modalCancelarDevolucionId: null,
  };

  consultarDevoluciones(params) {
    this.setState({ loading: true });
    axios
      .post(
        "devoluciones/selectDevolucionesVenta",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        console.log(res);
        if (res.data.success === 2) {
          this.setState({
            todasDevoluciones: res.data.data.map((value) => {
              return {
                ...value,
                fechaNota: value.fechaNota ? value.fechaNota : value.createdAt,
                accion: { _id: value._id, estado: value.estado, notaId: value._id, cancelacion: value.cancelacion, factura: value.factura },
              };
            }),
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ todasDevoluciones: [], loading: false, totalRecords: 0 });
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        message.error("Error al consultar las devoluciones");
        console.log(err);
      });
  }

  enviarDevolucion(value) {
    this.setState({ modalCorreo: true, modalCorreoId: value });
  }

  cerrarMandarCorreoDevolucion() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
  }

  cerrarCancelarDevolucion() {
    this.setState({
      modalCancelarDevolucion: false,
      modalCancelarDevolucionId: null,
    });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }

  render() {
    const columns = [
      {
        title: "Folio / OC",
        dataIndex: "folio",
        key: "folio",
        buscar: "folio",
        render: (_, record) => (
          <div>
            <div style={{ fontSize: "12px" }}>
              {record.folio}
            </div>
            {record.ordenDeCompra && (
              <div style={{ fontSize: "12px", color: "#666" }}>
                OC: {record.ordenDeCompra}
              </div>
            )}
          </div>
        ),
        width: "12%",
        ellipsis: true,
      },
      {
        title: "OC",
        dataIndex: "ordenDeCompra",
        key: "ordenDeCompra",
        buscar: "ordenDeCompra",
        responsive: [],
        width: 0,
      },
      {
        title: "Cliente / Vendedor",
        dataIndex: "cliente",
        key: "cliente",
        buscar: "cliente",
        width: "16%",
        ellipsis: true,
        render: (_, record) => (
          <>
            {record.cliente || "-"}
            <br />
            <span style={{ color: "#666" }}>
              Vendedor: {record.vendedor || "-"}
            </span>
          </>
        ),
      },
      {
        title: "Vendedor",
        dataIndex: "vendedor",
        key: "vendedor",
        buscar: "vendedor",
        responsive: [],
        width: 0,
      },
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        defaultSortOrder: "descend",
        sorter: true,
        render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
        width: "10%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Subtotal / Total",
        dataIndex: "subtotal",
        key: "subtotal",
        responsive: ["md"],
        sorter: true,
        buscar: "subtotal",
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666" }}>
              {dineroDisabledMask(record.subtotal)} {record.moneda}
            </div>
            <div style={{ fontWeight: "bold", fontSize: "12px" }}>
              {dineroDisabledMask(record.totalPagar)} {record.moneda}
            </div>
          </div>
        ),
        width: "12%",
        ellipsis: true,
        align: "right",
      },
      {
        title: "Saldo Pendiente",
        dataIndex: "saldoPendiente",
        key: "saldoPendiente",
        render: (value, record) => {
          if (record.estado === 0) return ""
          return (
            <div style={{ textAlign: "right", fontWeight: "bold" }}>
              {dineroDisabledMask(record.totalPagar - record.totalPagado)} {record.moneda}
            </div>
          );
        },
        width: "12%",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        responsive: ["md"],
        render: (value, record) => {
          if (value === 1) {
            return <Tag color="green" className="square-tag">Vigente</Tag>;
          }
          if (value === 0) {

            let satTag = null;
            if (record.factura) {
              if (record?.cancelacion?.statusCancelacion === 1) {
                satTag = (
                  <Tooltip title={`Estado: ${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)}`}>
                    <Tag color="orange" className="square-tag">SAT: Cancelación en proceso</Tag>
                  </Tooltip>
                );
              } else if (record?.cancelacion?.statusCancelacion === 2) {
                satTag = (
                  <Tooltip title={`Estado: ${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)}`}>
                    <Tag color="blue" className="square-tag">SAT: Cancelado</Tag>
                  </Tooltip>
                );
              } else if (record?.cancelacion?.statusCancelacion === 3) {
                satTag = (
                  <Tooltip title={`Estado: ${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)}`}>
                    <Tag color="yellow" className="square-tag">SAT: Rechazada</Tag>
                  </Tooltip>
                );
              } else {
                satTag = (
                  <Tag color="gray" className="square-tag">SAT: Sin Información</Tag>
                );
              }
            }

            return (
              <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                <Tag color="red" className="square-tag">Cancelada</Tag>
                {satTag}
              </div>
            );
          }
        },
        width: "10%",
        ellipsis: true,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        fixed: "right",
        width: "7%",
        align: "center",
        onCell: () => ({
          className: "acciones-sin-hover",
        }),
        render: (value, index) => {
          if (value.estado === 0) {
            let buttons = [];

            buttons.push(
              <Tooltip title="Ver PDF" placement="top" key={`ver-pdf-${value._id}`}>
                <ButtonItem
                  type="default"
                  size="small"
                  lila
                  icon={<BookFilled />}
                  onClick={() => this.enviarDevolucion(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );

            if (value.factura && value?.cancelacion?.statusCancelacion === 3) {
              buttons.push(
                <Popconfirm
                  key={`recancelar-${value._id}`}
                  title="¿Cancelar nuevamente el timbre fiscal?"
                  onConfirm={() =>
                    this.setState({
                      modalCancelarDevolucion: true,
                      modalCancelarDevolucionId: value._id,
                    })
                  }
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip title="Reintentar cancelación SAT" placement="top">
                    <CloseCircleOutlined style={{ color: "red", fontSize: 18 }} />
                  </Tooltip>
                </Popconfirm>
              );
            }

            return <Space direction="horizontal">{buttons}</Space>;
          }

          let buttons = [];

          buttons.push(
            <Tooltip title="Ver PDF" placement="top">
              <ButtonItem
                key={`ver-pdf-${value._id}`}
                type="default"
                size="small"
                lila
                icon={<BookFilled />}
                onClick={() => this.enviarDevolucion(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          buttons.push(
            <Popconfirm
              key={`cancelar-${value._id}`}
              title="¿Seguro que quieres cancelar esta devolución?"
              onConfirm={() => {
                this.setState({
                  modalCancelarDevolucion: true,
                  modalCancelarDevolucionId: value._id,
                });
              }}
              okText="Sí"
              cancelText="No"
            >
              <Tooltip title="Cancelar" placement="top">
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<CloseCircleOutlined />}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          return <Space direction="horizontal">{buttons}</Space>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Devoluciones Venta"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div className="header-actions">
              {window.innerWidth > 1000 && (
                <>
                  <SegmentedItem
                    options={[
                      { label: "Vigentes", value: 1 },
                      { label: "Canceladas", value: 2 },
                      { label: "Todos", value: 0 },
                    ]}
                    onChange={(value) => {
                      if (this.tableRef) {
                        this.tableRef.updateExternalFilters({ valor: value });
                      }
                      this.setState({ valor: value });
                    }}
                    value={this.state.valor}
                  />
                  <div className="header-divider"></div>
                </>
              )}
            </div>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verDevolucion", {
                  id: record._id,
                });
              },
            };
          }}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarDevoluciones.bind(this)}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasDevoluciones}
          columns={columns}
          filterStorageKey={"devolucionesFiltrosTabla" + this.props.empresaId}
          pagination={false}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={0}
        />
        <MandarCorreoDevolucion
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarMandarCorreoDevolucion={this.cerrarMandarCorreoDevolucion.bind(
            this
          )}
        />
        <CancelarDevolucion
          visible={this.state.modalCancelarDevolucion}
          id={this.state.modalCancelarDevolucionId}
          cerrarCancelarDevolucion={this.cerrarCancelarDevolucion.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoFacturaGlobal:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750916e798d4e0043687240"
      )?.activado,
  };
};

export default connect(mapStateToProps)(Devoluciones);